import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Checkout, CommonCMS, commonReplacements } from "@lib/constants/contentful";
import { useApplyLocalizedErrorMessages } from "@lib/validators/yupConfig";

export const useContactFormMicrocopy = () => {
    const { getMultiple, get } = useMicrocopy();

    // Configure Yup with localized error messages
    useApplyLocalizedErrorMessages();

    const step1microcopy = Checkout.step1;

    const microcopyValues = getMultiple(CommonCMS.page, [
        step1microcopy.formEmail.title,
        step1microcopy.formCountry.title,
        step1microcopy.formPhone.title,
        step1microcopy.formPhone.reasonForInsert,
        step1microcopy.button.title,
        Checkout.toggleNewsLetter,
    ]);

    const microcopyErrorTexts = getMultiple(CommonCMS.page, [
        step1microcopy.formEmail.error,
        step1microcopy.formPhone.error,
        step1microcopy.policy.error,
        Checkout.requiredFieldError,
        CommonCMS.error.maxCharacters,
    ]);

    const headers = {
        email: microcopyValues[step1microcopy.formEmail.title],
        country: microcopyValues[step1microcopy.formCountry.title],
        phone: microcopyValues[step1microcopy.formPhone.title],
        reasonForPhone: microcopyValues[step1microcopy.formPhone.reasonForInsert],
        continueToDelivery: microcopyValues[step1microcopy.button.title],
    };

    const headerErrors = {
        email: microcopyErrorTexts[step1microcopy.formEmail.error],
        phoneRequirements: microcopyErrorTexts[step1microcopy.formPhone.error],
        policy: microcopyErrorTexts[step1microcopy.policy.error],
        requiredField: microcopyErrorTexts[Checkout.requiredFieldError],
        maxEmailCharacters: get(CommonCMS.page, CommonCMS.error.maxCharacters, {
            replacements: commonReplacements.maxEmailCharacters,
        }),
        maxPhoneCharacters: get(CommonCMS.page, CommonCMS.error.maxCharacters, {
            replacements: commonReplacements.maxPhoneCharacters,
        }),
    };

    const accessibility = {
        toggleNewsletter: microcopyValues[Checkout.toggleNewsLetter],
    };

    return { headers, headerErrors, accessibility };
};
